var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 36V20H6V36C6 40.4183 9.58172 44 14 44H34C38.4183 44 42 40.4183 42 36V20H38V36C38 38.2091 36.2091 40 34 40H30V34C30 30.6863 27.3137 28 24 28C20.6863 28 18 30.6863 18 34V40H14C11.7909 40 10 38.2091 10 36ZM22 40H26V34C26 32.8954 25.1046 32 24 32C22.8954 32 22 32.8954 22 34V40Z",
    fill: "url(#paint0_linear_1215_4854)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2111 4C11.9046 4 8.64599 5.64773 6.85433 8.70044C6.28043 9.67828 5.63162 10.8472 5.11399 11.9641C4.85565 12.5215 4.6009 13.1279 4.40392 13.7317C4.22719 14.2734 4 15.0969 4 16C4 17.5943 4.39081 19.6172 5.80211 21.3107C7.32036 23.1326 9.53807 24 12 24C14.3372 24 16.1484 22.9101 17.3108 21.9371C17.7072 21.6054 18.2928 21.6054 18.6892 21.9371C19.8516 22.9101 21.6628 24 24 24C26.3372 24 28.1484 22.9101 29.3108 21.9371C29.7072 21.6054 30.2928 21.6054 30.6892 21.9371C31.8516 22.9101 33.6628 24 36 24C38.4619 24 40.6796 23.1326 42.1979 21.3107C43.6092 19.6172 44 17.5943 44 16C44 15.0969 43.7728 14.2734 43.5961 13.7317C43.3991 13.1279 43.1443 12.5215 42.886 11.9641C42.3684 10.8472 41.7196 9.67828 41.1457 8.70044C39.354 5.64773 36.0954 4 32.7889 4H15.2111ZM15.2111 8C13.205 8 11.3195 8.99497 10.3041 10.7251C9.21376 12.5828 8 14.8983 8 16C8 18 9 20 12 20C14.1034 20 15.7153 18.0336 16.4908 16.8582C16.8283 16.3467 17.3871 16 18 16C18.6129 16 19.1717 16.3467 19.5092 16.8582C20.2847 18.0336 21.8966 20 24 20C26.1034 20 27.7153 18.0336 28.4908 16.8582C28.8283 16.3467 29.3871 16 30 16C30.6129 16 31.1717 16.3467 31.5092 16.8582C32.2847 18.0336 33.8966 20 36 20C39 20 40 18 40 16C40 14.8983 38.7862 12.5828 37.6959 10.7251C36.6805 8.99497 34.795 8 32.7889 8H15.2111Z",
    fill: "url(#paint1_linear_1215_4854)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1215_4854",
    x1: 17.1141,
    y1: 25.92,
    x2: 31.1432,
    y2: 33.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1215_4854",
    x1: 16.349,
    y1: 8.93333,
    x2: 29.4888,
    y2: 18.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BF78"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.b5ac31ab647eb505ea7265da6eea2682.svg";
export { ForwardRef as ReactComponent };